var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "preWarning" },
    [
      _c(
        "el-tabs",
        {
          on: { "tab-click": _vm.handleTabClick },
          model: {
            value: _vm.activateTab,
            callback: function($$v) {
              _vm.activateTab = $$v
            },
            expression: "activateTab"
          }
        },
        [
          _vm.showTab("SE")
            ? _c(
                "el-tab-pane",
                { key: "se", attrs: { name: "se", lazy: _vm.curLob !== "SE" } },
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _c("span", { staticClass: "tabSpanStyle" }, [
                      _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_OceanExport")))
                    ]),
                    _c("span", [_vm._v("(")]),
                    _c("span", { staticStyle: { color: "#f56c6c" } }, [
                      _vm._v(_vm._s(_vm.lobCounts.se))
                    ]),
                    _c("span", [_vm._v(")")])
                  ]),
                  _c("tab-warning", {
                    key: "se",
                    ref: "se",
                    attrs: {
                      type: "se",
                      lob: "SE",
                      "keep-state": _vm.keepState
                    },
                    on: { resetCount: _vm.resetLobCount }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.showTab("SI")
            ? _c(
                "el-tab-pane",
                { key: "si", attrs: { name: "si", lazy: _vm.curLob !== "SI" } },
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _c("span", { staticClass: "tabSpanStyle" }, [
                      _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_OceanImport")))
                    ]),
                    _c("span", [_vm._v("(")]),
                    _c("span", { staticStyle: { color: "#f56c6c" } }, [
                      _vm._v(_vm._s(_vm.lobCounts.si))
                    ]),
                    _c("span", [_vm._v(")")])
                  ]),
                  _c("tab-warning", {
                    key: "si",
                    ref: "si",
                    attrs: {
                      type: "si",
                      lob: "SI",
                      "keep-state": _vm.keepState
                    },
                    on: { resetCount: _vm.resetLobCount }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.showTab("AE")
            ? _c(
                "el-tab-pane",
                { key: "ae", attrs: { name: "ae", lazy: _vm.curLob !== "AE" } },
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _c("span", { staticClass: "tabSpanStyle" }, [
                      _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_AirExport")))
                    ]),
                    _c("span", [_vm._v("(")]),
                    _c("span", { staticStyle: { color: "#f56c6c" } }, [
                      _vm._v(_vm._s(_vm.lobCounts.ae))
                    ]),
                    _c("span", [_vm._v(")")])
                  ]),
                  _c("tab-warning", {
                    key: "ae",
                    ref: "ae",
                    attrs: {
                      type: "ae",
                      lob: "AE",
                      "keep-state": _vm.keepState
                    },
                    on: { resetCount: _vm.resetLobCount }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.showTab("AI")
            ? _c(
                "el-tab-pane",
                { key: "ai", attrs: { name: "ai", lazy: _vm.curLob !== "AI" } },
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _c("span", { staticClass: "tabSpanStyle" }, [
                      _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_AirImport")))
                    ]),
                    _c("span", [_vm._v("(")]),
                    _c("span", { staticStyle: { color: "#f56c6c" } }, [
                      _vm._v(_vm._s(_vm.lobCounts.ai))
                    ]),
                    _c("span", [_vm._v(")")])
                  ]),
                  _c("tab-warning", {
                    key: "ai",
                    ref: "ai",
                    attrs: {
                      type: "ai",
                      lob: "AI",
                      "keep-state": _vm.keepState
                    },
                    on: { resetCount: _vm.resetLobCount }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.showTab("RE")
            ? _c(
                "el-tab-pane",
                { key: "re", attrs: { name: "re", lazy: _vm.curLob !== "RE" } },
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _c("span", { staticClass: "tabSpanStyle" }, [
                      _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_RailwayExport")))
                    ]),
                    _c("span", [_vm._v("(")]),
                    _c("span", { staticStyle: { color: "#f56c6c" } }, [
                      _vm._v(_vm._s(_vm.lobCounts.re))
                    ]),
                    _c("span", [_vm._v(")")])
                  ]),
                  _c("tab-warning", {
                    key: "re",
                    ref: "re",
                    attrs: {
                      type: "re",
                      lob: "RE",
                      "keep-state": _vm.keepState
                    },
                    on: { resetCount: _vm.resetLobCount }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.showTab("RI")
            ? _c(
                "el-tab-pane",
                { key: "ri", attrs: { name: "ri", lazy: _vm.curLob !== "RI" } },
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _c("span", { staticClass: "tabSpanStyle" }, [
                      _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_RailwayImport")))
                    ]),
                    _c("span", [_vm._v("(")]),
                    _c("span", { staticStyle: { color: "#f56c6c" } }, [
                      _vm._v(_vm._s(_vm.lobCounts.ri))
                    ]),
                    _c("span", [_vm._v(")")])
                  ]),
                  _c("tab-warning", {
                    key: "ri",
                    ref: "ri",
                    attrs: {
                      type: "ri",
                      lob: "RI",
                      "keep-state": _vm.keepState
                    },
                    on: { resetCount: _vm.resetLobCount }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.showTab("IE")
            ? _c(
                "el-tab-pane",
                { key: "ie", attrs: { name: "ie", lazy: _vm.curLob !== "IE" } },
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _c("span", { staticClass: "tabSpanStyle" }, [
                      _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_IntegratedJob")))
                    ]),
                    _c("span", [_vm._v("(")]),
                    _c("span", { staticStyle: { color: "#f56c6c" } }, [
                      _vm._v(_vm._s(_vm.lobCounts.ie))
                    ]),
                    _c("span", [_vm._v(")")])
                  ]),
                  _c("tab-warning", {
                    key: "ie",
                    ref: "ie",
                    attrs: {
                      type: "ie",
                      lob: "IE",
                      "keep-state": _vm.keepState
                    },
                    on: { resetCount: _vm.resetLobCount }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }